export enum CarouselVariant {
  GROUP = 'group',
  SEPARATED = 'separated'
}
